module.exports = __webpack_public_path__ + "img/error-vector.90978b00.svg";